import { render, staticRenderFns } from "./ReorderTable.vue?vue&type=template&id=554286ef"
import script from "./ReorderTable.vue?vue&type=script&lang=ts"
export * from "./ReorderTable.vue?vue&type=script&lang=ts"
import style0 from "./ReorderTable.vue?vue&type=style&index=0&id=554286ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports